import type { ReactNode, MouseEvent } from 'react'
import styles from './Modal.module.css'

interface ModalProps {
  /** Вызывается при клике вне контента / по крестику */
  onClose: () => void
  /** Содержимое модалки */
  children: ReactNode
}

/**
 * Модалка с overlay. Клик по overlay закрывает модалку, клик внутри — нет.
 * @param onClose - Колбэк закрытия
 * @param children - Содержимое модалки
 */
export const Modal = ({ onClose, children }: ModalProps) => {
  const stop = (e: MouseEvent<HTMLDivElement>) => e.stopPropagation()

  return (
    <div className={styles.overlay} onClick={onClose} role="presentation">
      <div className={styles.sheet} onClick={stop}>
        {children}
      </div>
    </div>
  )
}
